import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase.js";

/**
 * The dashboard aggregates every other tab, so it reads wide but shallow —
 * one query per table with only the columns the tiles need, rather than
 * reusing the per-tab hooks and pulling far more than required.
 */

export function useDashboardData() {
  const rentals = useQuery({
    queryKey: ["rentals", "dashboard"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("rentals")
        .select(
          "id,equipment_id,customer_id,start_date,start_time,end_date,end_time," +
            "returned_date,returned_time,status,paid,paid_date,total," +
            "equipment(name),customers(name)"
        )
        .order("start_date", { ascending: false });
      if (error) throw new Error(error.message);
      return data;
    },
  });

  const equipment = useQuery({
    queryKey: ["equipment", "dashboard"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("equipment")
        .select("id,name,status,next_service_date");
      if (error) throw new Error(error.message);
      return data;
    },
  });

  const customers = useQuery({
    queryKey: ["customers", "dashboard"],
    queryFn: async () => {
      const { data, error } = await supabase.from("customers").select("id,name,coi_expires");
      if (error) throw new Error(error.message);
      return data;
    },
  });

  return {
    rentals,
    equipment,
    customers,
    isPending: rentals.isPending || equipment.isPending || customers.isPending,
    error: rentals.error ?? equipment.error ?? customers.error,
    refetch: () => { rentals.refetch(); equipment.refetch(); customers.refetch(); },
  };
}
